/* STREET BILL BLACK MARKET - nedtællinger, lykkehjul og tilbage-til-shoppen-link */
(function () {
  'use strict';

  var isMarket = document.body.classList.contains('bm-dark');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) { return null; }
  }

  /* ------------------------------------------------------------------
     Switch: "Shop" fører tilbage til den side kunden kom fra
     ------------------------------------------------------------------ */
  try {
    if (!isMarket) {
      window.sessionStorage.setItem('bm_return', location.pathname + location.search);
    } else {
      var back = window.sessionStorage.getItem('bm_return');
      if (back && back.charAt(0) === '/' && back.charAt(1) !== '/') {
        document.querySelectorAll('[data-bm-shop-link]').forEach(function (a) { a.setAttribute('href', back); });
      }
    }
  } catch (e) {}

  /* Mobil-vippekontakten når lige at vippe, før siden skifter */
  document.querySelectorAll('.bm-switch a').forEach(function (a) {
    a.addEventListener('click', function () {
      if (a.getAttribute('aria-current') === 'true') return;
      a.closest('.bm-switch').classList.add('is-flipping');
    });
  });
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.bm-switch.is-flipping').forEach(function (s) { s.classList.remove('is-flipping'); });
  });

  /* ------------------------------------------------------------------
     Nedtælling til Black Friday
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-bm-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-bm-countdown'));
    if (isNaN(target)) return;
    var out = el.querySelector('b') || el;
    var tick = function () {
      var d = target - new Date();
      if (d <= -864e5) { el.hidden = true; return; }
      if (d <= 0) { out.textContent = 'i dag'; return; }
      var dd = Math.floor(d / 864e5), h = Math.floor(d % 864e5 / 36e5), m = Math.floor(d % 36e5 / 6e4);
      out.textContent = dd + ' dage ' + h + ' t ' + m + ' min';
    };
    tick();
    window.setInterval(tick, 30000);
  });

  /* ------------------------------------------------------------------
     Stor nedtælling for hele Black Month: før start -> til åbningen, derefter -> til slutningen
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-bm-timer]').forEach(function (el) {
    var start = new Date(el.getAttribute('data-start')), end = new Date(el.getAttribute('data-end'));
    if (isNaN(end)) return;
    var q = function (sel) { return el.querySelector(sel); };
    var out = { d: q('[data-bm-d]'), h: q('[data-bm-h]'), m: q('[data-bm-m]'), s: q('[data-bm-s]') };
    var label = q('[data-bm-timer-label]'), bar = q('[data-bm-timer-bar]'), day = q('[data-bm-timer-day]');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var iv;
    var tick = function () {
      var now = new Date(), early = !isNaN(start) && now < start, before = early && !el.hasAttribute('data-only-end'), ms = (before ? start : end) - now;
      if (!before && ms <= 0) { el.hidden = true; window.clearInterval(iv); return; }
      out.d.textContent = pad(Math.floor(ms / 864e5));
      out.h.textContent = pad(Math.floor(ms % 864e5 / 36e5));
      out.m.textContent = pad(Math.floor(ms % 36e5 / 6e4));
      out.s.textContent = pad(Math.floor(ms % 6e4 / 1e3));
      label.textContent = el.getAttribute(before ? 'data-label-before' : 'data-label-during');
      if (early || isNaN(start)) {
        bar.style.width = '0%';
        day.textContent = el.getAttribute('data-before-text') || '';
      } else {
        var total = Math.max(1, Math.ceil((end - start) / 864e5)), n = Math.min(total, Math.floor((now - start) / 864e5) + 1);
        bar.style.width = Math.min(100, (now - start) / (end - start) * 100).toFixed(2) + '%';
        day.textContent = (el.getAttribute('data-day-text') || '').replace('[dag]', n).replace('[dage]', total);
      }
    };
    tick();
    iv = window.setInterval(tick, 1000);
  });

  /* Kompakt nedtælling i banneret på den normale shop: "Åbner om 41d 09t 10m 35s" */
  var miniTimer = function (el) {   // også til produktsidens gaveboks, der sættes ind senere (visGaveboks)
    if (el.bmTid) return;
    el.bmTid = true;
    var start = new Date(el.getAttribute('data-start') || NaN), end = new Date(el.getAttribute('data-end'));
    if (isNaN(end)) return;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var iv;
    var tick = function () {
      var now = new Date(), before = !isNaN(start) && now < start, ms = (before ? start : end) - now;
      if (!before && ms <= 0) {
        el.hidden = true; window.clearInterval(iv);
        /* THE VAULT åbner: hent siden igen, så serveren viser den ulåste udgave (højst én gang i minuttet) */
        if (el.getAttribute('data-reload') === 'true') {
          try {
            var lastReload = parseInt(window.sessionStorage.getItem('bm_vault_reload') || '0', 10);
            if (Date.now() - lastReload > 60000) { window.sessionStorage.setItem('bm_vault_reload', String(Date.now())); location.reload(); }
          } catch (e) {}
        }
        return;
      }
      var prefix = el.getAttribute(before ? 'data-before' : 'data-during') || '';
      el.textContent = (prefix ? prefix + ' ' : '') +
        Math.floor(ms / 864e5) + 'd ' + pad(Math.floor(ms % 864e5 / 36e5)) + 't ' + pad(Math.floor(ms % 36e5 / 6e4)) + 'm';
      var sec = document.createElement('span');          // sekunderne skjules på mobil, hvor der ikke er plads i banneret
      sec.className = 'bm-bar__sec';
      sec.textContent = ' ' + pad(Math.floor(ms % 6e4 / 1e3)) + 's';
      el.appendChild(sec);
      el.classList.add('is-live');
    };
    tick();
    iv = window.setInterval(tick, 1000);
  };
  document.querySelectorAll('[data-bm-mini-timer]').forEach(miniTimer);

  /* ------------------------------------------------------------------
     FLASH-SKIFT (14-10, Thomas: "jeg skal kunne stole på at hvert flash sale skifter dagligt"): Shopify kan servere en gemt
     udgave af siden, hvor klokken i Liquid er fra før skiftet. [data-bm-skift] = næste skift (unix-sekunder) fra THE DROP og
     produktsidens flash-boks. Er det passeret, når siden åbnes - eller passerer det, mens den står åben - hentes siden igen
     med ?bm=<tid>, som Shopify ikke har gemt. Højst én gang i minuttet; ?bm fjernes igen fra adresselinjen.
     ------------------------------------------------------------------ */
  (function () {
    try {
      var u0 = new URL(location.href);
      if (u0.searchParams.has('bm')) { u0.searchParams.delete('bm'); history.replaceState(history.state, '', u0.toString()); }
    } catch (e) {}
    var tider = [].map.call(document.querySelectorAll('[data-bm-skift]'), function (el) { return parseInt(el.getAttribute('data-bm-skift'), 10) * 1000; })
      .filter(function (t) { return t > 0; });
    if (!tider.length) return;
    var naeste = Math.min.apply(null, tider);
    var frisk = function () {
      try {
        if (Date.now() - parseInt(window.sessionStorage.getItem('bm_skift') || '0', 10) < 60000) return;
        window.sessionStorage.setItem('bm_skift', String(Date.now()));
      } catch (e) {}
      var u = new URL(location.href); u.searchParams.set('bm', String(Date.now())); location.replace(u.toString());
    };
    var vent = naeste - Date.now();
    if (vent <= 0) frisk();
    else if (vent < 2147483647) window.setTimeout(frisk, vent + 1500);   // 1,5 s efter skiftet
  })();

  /* ------------------------------------------------------------------
     THE VAULT-kortet på forsiden: låsen er lys i billedet (12-10, afløser tapen)
     - Kunden har adgang (afgjort på serveren = data-access): kortet låser op, når det kommer i syne. Displayet
       scanner gult og bliver grønt, og døren går på klem (lysstribe + lys over gulvet). Én gang pr. session.
     - Uden adgang: et tryk får displayet til at blinke hurtigt rødt, før siden skifter til døren.
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-bm-vrig]').forEach(function (rig) {
    var card = rig.closest('a');
    if (!card) return;
    var flag = card.querySelector('[data-open-text]');
    var opened = function () {
      rig.classList.remove('is-locked', 'is-scanning');
      rig.classList.add('is-open');
      if (flag) flag.textContent = flag.getAttribute('data-open-text');
    };
    if (rig.hasAttribute('data-access')) {
      var seen = false;
      try { seen = window.sessionStorage.getItem('bm_vault_card') === '1'; } catch (e) {}
      if (seen || reduceMotion || !('IntersectionObserver' in window)) { rig.classList.add('no-anim'); opened(); return; }
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        window.setTimeout(function () { rig.classList.add('is-scanning'); }, 350);
        window.setTimeout(function () {
          opened();
          try { window.sessionStorage.setItem('bm_vault_card', '1'); } catch (e) {}
        }, 1250);
      }, { threshold: 0.6 });
      io.observe(card);
      return;
    }
    card.addEventListener('click', function (e) {
      if (reduceMotion || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      rig.classList.remove('is-denied'); void rig.offsetWidth; rig.classList.add('is-denied');
      if (navigator.vibrate) { try { navigator.vibrate([40, 50, 40]); } catch (err) {} }
      window.setTimeout(function () { location.href = card.href; }, 520);
    });
  });

  /* ------------------------------------------------------------------
     THE VAULT-pris (06-10): koden står aldrig i siden. Dørkoden tjekkes på Club-serveren med loft over forsøg pr. besøgende;
     rigtig kode giver en lang nøgle, som lægges på kurven (attributten _bm_vault) og huskes i browseren, så en ny kurv (fx efter
     et køb) får den igen. Club-appens prisfunktion giver kun vault-prisen til en kurv med nøglen, og theme.liquid viser kun
     vault-priser, når kurvens nøgle passer (bmVault.ok, tjekket på serveren). Kunder, THE VAULT er åben for, får nøglen fra
     serveren (bmVault.noegle). Test: ?vault=1 glemmer nøglen og viser døren igen.
     ------------------------------------------------------------------ */
  var vault = window.bmVault;
  var vaultKurv = function (noegle) {   // læg nøglen på kurven; sektionen bm-vault-check svarer, om den passer
    return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _bm_vault: noegle }, sections: 'bm-vault-check' })
    }).then(function (r) { return r.json(); }).then(function (kurv) {
      var ok = noegle !== '' && /bm-vault-ok/.test((kurv.sections || {})['bm-vault-check'] || '');
      store('bm_vault_noegle', ok ? noegle : '');
      if (ok) {
        document.documentElement.classList.add('bm-vault-unlocked');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));   // kurvskuffen viser vault-prisen med det samme
      }
      return ok;
    });
  };
  window.bmVaultTjek = function (kode) {   // -> { ok: true } | { ok: false } | { vent: minutter } | { fejl: true }
    return fetch('https://club-api.street-bill.dk/vault/tjek', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ kode: kode, shop: window.Shopify && window.Shopify.shop })
    }).then(function (r) {
      if (r.status >= 500) throw new Error('vault ' + r.status);
      return r.json();
    }).then(function (svar) {
      if (svar.minutter) return { vent: svar.minutter };
      if (!svar.ok) return { ok: false };
      return vaultKurv(svar.noegle).then(function (ok) { return ok ? { ok: true } : { fejl: true }; });
    }).catch(function () { return { fejl: true }; });
  };
  if (vault && /[?&]vault=1/.test(location.search)) {
    store('bm_vault_noegle', '');
    try { window.sessionStorage.removeItem('bm_vault_seen'); window.sessionStorage.removeItem('bm_vault_card'); } catch (e) {}   // også forsidekortets oplåsning
    if (vault.ok) vaultKurv('').then(function () { location.replace(location.pathname); });
  } else if (vault && !vault.ok && (vault.noegle || store('bm_vault_noegle'))) {
    vaultKurv(vault.noegle || store('bm_vault_noegle')).then(function (ok) {
      if (ok && document.getElementById('bm-vaultlock')) location.reload();   // står man ved døren med en husket nøgle: varerne uden lås
    });
  }

  /* ------------------------------------------------------------------
     TRAPPEN (06-10): Black Week-gaver efter kurvens størrelse (window.bmTrappe fra theme.liquid).
     Når kurven når et trin, lægges gaven i kurven (linjeegenskaben _bm_trappe); falder kurven under, fjernes den igen.
     Fjerner kunden selv en gave, lægges den ikke i igen i denne session. Gaverne er kun gratis, mens rabatterne
     "TRAPPE: ..." kører (Club-appens kurv-deal) - derfor lægges de kun i kurven, når trappen er live (ikke i preview).
     Kurvens beløb regnes som kurv-deal: alle andre varer før rabatkoder. Forsidens trappe ([data-bm-trappe]) følger med.
     ------------------------------------------------------------------ */
  var trappe = window.bmTrappe;
  if (trappe && trappe.trin) {
    // QA: ?trappe=1 nulstiller låsene, gave-valgene og "Låst op"-øjeblikket i denne fane, så animationerne kan ses igen
    if (/[?&]trappe=1(&|$)/.test(window.location.search)) {
      try { Object.keys(window.sessionStorage).forEach(function (k) { if (k.indexOf('bm_tr') === 0 || k.indexOf('bm_lo_') === 0) window.sessionStorage.removeItem(k); }); } catch (e) {}
    }
    var trappeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var gave = {};
    trappe.trin.forEach(function (t) { gave[t.produkt] = true; });
    var trappeKr = function (n) { return Math.round(n).toLocaleString('da-DK') + '\u00a0kr'; };   // hårdt mellemrum: "kr" knækker aldrig alene
    var sess = function (k, v) {
      try { if (v === undefined) return window.sessionStorage.getItem(k); window.sessionStorage.setItem(k, v); } catch (e) {}
      return null;
    };
    var kurvBeloeb = function (kurv) {
      return kurv.items.reduce(function (s, it) { return gave[it.product_id] ? s : s + it.original_line_price; }, 0) / 100;
    };
    /* Låsen åbner selv, når kurven når trinnet (Thomas 06-10): fyldet stiger til toppen, låsen vrikker og springer op.
       Er trappen ikke i billedet, sker det, når den rulles ind. Åbnede låse huskes i sessionen (ingen gentagelse). */
    var aabnSnart = function (trin, ms) {
      clearTimeout(trin.bmTimer);
      trin.bmTimer = setTimeout(function tjek() {
        if (!trin.classList.contains('is-op') || trin.classList.contains('is-aaben')) return;
        // kunden skal se det: vent, mens kurvskuffen er åben eller fanen er skjult; uden for billedet åbner IO den senere
        if (document.hidden || document.querySelector('cart-drawer[open]')) { trin.bmTimer = setTimeout(tjek, 400); return; }
        if (!iBilledet(trin.closest('.bm-tr'))) return;
        sess('bm_tr_aaben_' + trin.getAttribute('data-min'), '1');
        trin.classList.add('is-aaben');
      }, ms);
    };
    var iBilledet = function (el) {
      var r = el.getBoundingClientRect();
      return !el.classList.contains('is-vent') && r.top < window.innerHeight * .8 && r.bottom > 0;
    };
    var visTrappe = function (b) {
      document.querySelectorAll('[data-bm-trappe]').forEach(function (sek) {
        var naeste = null, forste = null;
        sek.querySelectorAll('.bm-tr__trin').forEach(function (trin) {
          var min = parseFloat(trin.getAttribute('data-min')), udsolgt = trin.classList.contains('is-udsolgt');
          var op = b >= min && !udsolgt, noegle = 'bm_tr_aaben_' + min;
          trin.style.setProperty('--fyld', Math.min(1, b / min).toFixed(3));
          trin.classList.toggle('is-op', op);
          if (!op) {   // under grænsen igen: låsen lukker
            sess(noegle, '');
            trin.classList.remove('is-aaben', 'is-stille');
          } else if (sess(noegle) === '1') {
            if (!trin.classList.contains('is-aaben')) trin.classList.add('is-aaben', 'is-stille');
          } else if (iBilledet(trin.closest('.bm-tr'))) {
            aabnSnart(trin, 950);   // efter fyldets 0,9 s
          }
          var gave = trappe.trin.filter(function (t) { return t.min === min; })[0];
          var iKurv = !!gave && trappe.live && sess('bm_trappe_fra_' + gave.variant) !== '1';   // ikke hvis kunden selv fjernede den
          var st = trin.querySelector('[data-status]');
          if (st) st.textContent = udsolgt ? sek.getAttribute('data-udsolgt')
            : !op ? sek.getAttribute('data-mangler') + ' ' + trappeKr(min - b)
            : iKurv ? sek.getAttribute('data-op') : 'Låst op';
          var laas = trin.querySelector('[data-bm-laas]');
          if (laas && st) laas.setAttribute('aria-label', (op ? 'Låst op' : 'Låst') + ': ' + trin.getAttribute('data-navn') + ' - ' + st.textContent);
          if (udsolgt) return;
          if (!forste) forste = trin;
          if (!op && !naeste) naeste = trin;
        });
        var note = sek.querySelector('[data-bm-trappe-note]');
        if (!note) return;
        var din = b > 0 ? 'Din kurv: ' + trappeKr(b) + '. ' : '';
        if (!naeste) { note.textContent = din + 'Alle gaver er låst op.'; return; }
        note.textContent = din + 'Køb for ' + trappeKr(parseFloat(naeste.getAttribute('data-min')) - b) + ' mere, og få ' +
          naeste.getAttribute('data-navn') + (naeste === forste ? ' gratis med.' : ' oveni.');
      });
    };
    /* Produktsidens gaveboks (06-10 v3): regnes om ved kurv- og størrelsesskift - samme regel og tekster som
       snippets/bm-trappe-pdp.liquid. "Med denne" = kurven + den valgte størrelses pris (er varen i kurven, tæller den ikke igen). */
    var sidsteKurv = null;
    var tekst = function (el, foer, fremhaev, tag, efter) {
      if (!el) return;
      el.textContent = foer;
      var f = document.createElement(tag);
      f.textContent = fremhaev;
      el.appendChild(f);
      el.appendChild(document.createTextNode(efter));
    };
    var visGaveboks = function (kurv) {
      if (kurv) sidsteKurv = kurv;
      var boks = document.querySelector('[data-bm-trappe-pdp]');
      if (!boks || !sidsteKurv) return;
      var tid = boks.querySelector('[data-bm-mini-timer]');
      if (tid) miniTimer(tid);
      var produkt = parseInt(boks.getAttribute('data-produkt'), 10);
      var b = kurvBeloeb(sidsteKurv), priser = {};
      try { priser = JSON.parse(boks.getAttribute('data-priser')); } catch (e) {}
      var st = document.querySelector('product-sticky-add-to-cart');
      var form = (st && document.getElementById(st.getAttribute('main-product-form'))) || document.querySelector('form[id^="product-form-main"]');
      var valgt = form && form.querySelector('[name="id"]');
      var pris = valgt && priser[valgt.value] !== undefined ? priser[valgt.value] : priser[Object.keys(priser)[0]] || 0;
      var iKurv = sidsteKurv.items.some(function (it) { return it.product_id === produkt; });
      var med = iKurv ? b : b + pris;
      var nDenne = 0, nLaast = 0, denneNavn = '';
      boks.querySelectorAll('.bm-mt__trin').forEach(function (r) {
        var min = parseFloat(r.getAttribute('data-min'));
        var t = r.classList.contains('is-udsolgt') ? 'udsolgt' : b >= min ? 'har' : med >= min ? 'denne' : 'laast';
        var foer = r.getAttribute('data-t');
        var ny = t === 'har' && (r.hasAttribute('data-aabn') || r.classList.contains('is-ny') || foer === 'laast' || foer === 'denne');
        if (ny && !r.classList.contains('is-spil')) r.setAttribute('data-aabn', '1');   // låst op lige nu: står frosset, til kurven lukkes
        if (t !== 'har') r.removeAttribute('data-aabn');
        r.setAttribute('data-t', t);
        r.className = 'bm-mt__trin is-' + t + (ny ? ' is-ny' : '') + (ny && r.classList.contains('is-spil') ? ' is-spil' : '');
        var st = r.querySelector('[data-status]');
        if (st) st.textContent = t === 'udsolgt' ? 'Udsolgt' : t === 'har' ? 'I kurven' : t === 'denne' ? 'Låses op' : 'Mangler ' + trappeKr(min - med);
        if (t === 'denne') { nDenne++; denneNavn = r.getAttribute('data-navn'); }
        if (t === 'laast') nLaast++;
      });
      var titel = boks.querySelector('[data-titel]');
      if (nDenne > 1) tekst(titel, 'Læg den i kurven\u00a0- få ', nDenne + ' gaver', 'em', ' gratis');
      else if (nDenne === 1) tekst(titel, 'Læg den i kurven\u00a0- få ', denneNavn, 'em', ' gratis');
      else if (nLaast > 0) tekst(titel, 'Du går glip af ', nLaast + (nLaast === 1 ? ' gave' : ' gaver'), 'em', '');
      else tekst(titel, 'Alle gaverne er ', 'dine', 'em', '');
    };
    /* "Låst op"-øjeblikket (07-10 v2, Thomas: "animationen skal bestå og blive"): mini-trappen (snippets/bm-mini-trappe.liquid)
       står fast i kurvskuffen og i produktsidens gaveboks - gaver i kurven åbne, resten frosset.
       - kurvskuffen: en gave, der er kommet i kurven og ikke er fejret i denne fane, står frosset (is-ny), til skuffen er
         åben, og springer så (is-spil): låsen falder af, isen splintres, "Låst op!" stemples ind. Bagefter står den åben.
         Markeringen sker i selve MutationObserver-kaldet (før skærmen tegnes), så den åbne gave aldrig blinker frem først.
         Bliver skuffen tegnet om midt i forløbet, starter det forfra. Ryger gaven ud af kurven, kan den fejres igen.
       - produktsiden: trinnet, varen lige låste op, står frosset, til kurven er lukket og boksen er i billedet */
    var skuffe = document.querySelector('cart-drawer');
    var fejret = function (min, v) { return sess('bm_lo_' + min, v); };
    var spilKurv = function () {
      if (!skuffe || !skuffe.hasAttribute('open') || document.hidden) return;
      var nye = skuffe.querySelectorAll('[data-bm-mt] .bm-mt__trin.is-ny:not(.is-spil), .bm-tk__trin.is-ny:not(.is-spil)');   // .bm-tk = kurvens gave-bjælke (12-10)
      if (!nye.length) return;
      var lo = skuffe.querySelector('[data-bm-lo]');
      [].forEach.call(nye, function (r, i) {
        setTimeout(function () { r.classList.add('is-spil'); }, 350 + i * 300);   // efter skuffens indglidning
        setTimeout(function () { fejret(r.getAttribute('data-min'), '1'); }, 2900 + i * 300);
      });
      if (lo) setTimeout(function () { lo.classList.add('is-spil'); }, 350);
    };
    var markerKurv = function () {
      if (!skuffe) return;
      skuffe.querySelectorAll('[data-bm-mt] .bm-mt__trin, .bm-tk__trin').forEach(function (r) {
        var min = r.getAttribute('data-min');
        if (!r.classList.contains('is-har')) { fejret(min, ''); return; }
        if (fejret(min) !== '1' && !r.classList.contains('is-ny')) r.classList.add('is-ny');
      });
    };
    var aabnRaekker = function () {
      var boks = document.querySelector('[data-bm-trappe-pdp]');
      var nye = boks ? boks.querySelectorAll('.bm-mt__trin[data-aabn]') : [];
      if (!nye.length) return;
      if (document.hidden || (skuffe && skuffe.hasAttribute('open')) || !iBilledet(boks)) { setTimeout(aabnRaekker, 400); return; }
      [].forEach.call(nye, function (r, i) {
        r.removeAttribute('data-aabn');
        setTimeout(function () {
          r.classList.add('is-ny', 'is-spil');
          setTimeout(function () { r.classList.remove('is-ny', 'is-spil'); }, 2700);
        }, 250 + i * 300);
      });
    };
    if (skuffe && 'MutationObserver' in window) {
      markerKurv();
      new MutationObserver(function () { markerKurv(); spilKurv(); })
        .observe(skuffe, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
    }
    document.addEventListener('visibilitychange', spilKurv);
    document.addEventListener('cart:change', function () { setTimeout(aabnRaekker, 300); });

    document.addEventListener('change', function (e) {   // ny størrelse = ny pris: temaet opdaterer formularens id lige efter
      if (e.target.closest && e.target.closest('variant-picker')) setTimeout(function () { visGaveboks(); }, 60);
    });

    /* Tryk på en lås: ikke nået = nej-rysten (statussen viser, hvad der mangler); nået = åbner med det samme */
    document.addEventListener('click', function (e) {
      var laas = e.target.closest && e.target.closest('[data-bm-laas]');
      var trin = laas && laas.closest('.bm-tr__trin');
      if (!trin || trin.classList.contains('is-aaben')) return;
      if (trin.classList.contains('is-op')) { aabnSnart(trin, 0); return; }
      trin.classList.remove('is-nej'); void trin.offsetWidth; trin.classList.add('is-nej');
    });
    /* Trappen i billedet: første gang rejser trinene sig fra gulvet (kun hvis den startede uden for skærmen), og nåede trin
       åbner deres lås - hver gang trappen rulles ind og et trin venter */
    if ('IntersectionObserver' in window) {
      var roligt = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      document.querySelectorAll('.bm-tr').forEach(function (tr) {
        var vent = !roligt && tr.getBoundingClientRect().top >= window.innerHeight;
        if (vent) tr.classList.add('is-vent');
        var ind = function () {
          var ms = 950;
          if (tr.classList.contains('is-vent')) {
            tr.classList.add('is-ind');
            requestAnimationFrame(function () { tr.classList.remove('is-vent'); });
            setTimeout(function () { tr.classList.remove('is-ind'); }, 2200);
            ms = 1400;   // trinene rejser sig, fyldet stiger, så springer låsen
          }
          tr.querySelectorAll('.bm-tr__trin.is-op:not(.is-aaben)').forEach(function (trin, i) { aabnSnart(trin, ms + i * 160); });
        };
        new IntersectionObserver(function (es) { if (es[0].isIntersecting) ind(); }, { rootMargin: '0px 0px -20% 0px' }).observe(tr);
        if (vent) setTimeout(function () { if (tr.classList.contains('is-vent')) ind(); }, 8000);   // sikkerhedsnet
      });
    }
    var arbejder = false;
    var afstem = function (kurv) {
      var b = kurvBeloeb(kurv);
      trappe.trin.forEach(function (t) {   // gaven er ude af kurven (også tømt kurv): må fejres igen
        if (!kurv.items.some(function (it) { return it.product_id === t.produkt; })) fejret(t.min, '');
      });
      visTrappe(b);
      visGaveboks(kurv);
      if (!trappe.live || arbejder) return;
      var opgaver = [];
      trappe.trin.forEach(function (t) {
        var linje = kurv.items.filter(function (it) { return it.variant_id === t.variant && it.properties && it.properties._bm_trappe; })[0];
        var fortjent = b >= t.min && t.ledig, lagt = 'bm_trappe_lagt_' + t.variant, fra = 'bm_trappe_fra_' + t.variant;
        if (fortjent && !linje) {
          if (sess(lagt) === '1') sess(fra, '1');   // vi lagde den i, og nu er den væk: kunden har selv fjernet den
          if (sess(fra) === '1') return;
          opgaver.push(function () {
            return fetch(trappeRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: t.variant, quantity: 1, properties: { _bm_trappe: '1' } }] }) })
              .then(function (r) { if (r.ok) sess(lagt, '1'); });
          });
        } else if (!fortjent && linje) {
          opgaver.push(function () {
            return fetch(trappeRoot + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: linje.key, quantity: 0 }) }).then(function () { sess(lagt, ''); });
          });
        }
      });
      if (!opgaver.length) return;
      arbejder = true;
      opgaver.reduce(function (p, f) { return p.then(f); }, Promise.resolve()).catch(function () {}).then(function () {
        arbejder = false;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));   // kurvskuffen viser gaven
      });
    };
    document.addEventListener('cart:change', function (e) { if (e.detail && e.detail.cart) afstem(e.detail.cart); });
    var laesKurv = function () { fetch(trappeRoot + 'cart.js').then(function (r) { return r.json(); }).then(afstem).catch(function () {}); };
    laesKurv();
    // tilbage på siden (tilbage-knap = gemt side, eller en anden fane): kurven kan være ændret imens - læs den igen
    window.addEventListener('pageshow', function (e) { if (e.persisted) laesKurv(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) laesKurv(); });
  }

  /* ------------------------------------------------------------------
     FAST KØBSKNAP PÅ MOBIL (06-10): temaets faste "Tilføj til kurv" (product-sticky-add-to-cart) vises først, når man har
     scrollet forbi hele købsformularen. På mobil vises den, så snart den rigtige knap er ude af syne - også før man er nået
     ned til den. Størrelsesvagt: har kunden ikke selv valgt størrelse, ruller den faste knap op til størrelsesvælgeren og
     markerer den i stedet for at lægge den forvalgte størrelse i kurven (63 % af returerne skyldes størrelse).
     ------------------------------------------------------------------ */
  var fastKnap = document.querySelector('product-sticky-add-to-cart');
  var hovedForm = fastKnap && document.getElementById(fastKnap.getAttribute('main-product-form'));
  var hovedKnap = hovedForm && hovedForm.querySelector('button[type="submit"]');
  if (hovedKnap && window.matchMedia && 'IntersectionObserver' in window) {
    var mobil = window.matchMedia('(max-width: 699px)');   // Impacts sm-grænse: under 700 px vises den massive knap
    var fod = document.querySelector('.shopify-section--footer');
    var knapSes = true, fodSes = false;
    var visFast = function () { fastKnap.classList.toggle('bm-synlig', mobil.matches && !knapSes && !fodSes); };
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.target === hovedKnap) knapSes = e.isIntersecting; else fodSes = e.isIntersecting; });
      visFast();
    });
    io.observe(hovedKnap);
    if (fod) io.observe(fod);
    var vaelger = document.querySelector('.product-info variant-picker') || document.querySelector('variant-picker');
    var valgtStr = /[?&]variant=/.test(window.location.search);   // kommer fra et størrelsesfilter = størrelsen er valgt
    if (vaelger) vaelger.addEventListener('change', function () { valgtStr = true; });
    fastKnap.addEventListener('click', function (e) {
      if (valgtStr || !vaelger || !mobil.matches || !e.target.closest('button[type="submit"]')) return;
      if (vaelger.querySelectorAll('input[type="radio"]:not(:disabled)').length < 2) return;   // kun én størrelse at vælge
      e.preventDefault();
      e.stopImmediatePropagation();
      vaelger.scrollIntoView({ behavior: 'smooth', block: 'center' });
      vaelger.classList.remove('bm-vaelg'); void vaelger.offsetWidth; vaelger.classList.add('bm-vaelg');
    }, true);
  }

  /* ------------------------------------------------------------------
     THE ARCADE - skrabelod (09-10; Thomas: "skrab 3 ens", "skal scratche alt før den trigger", "alle lod skal ikke vinde").
     Loddet trækkes på Club-serveren (club-api /arcade/lod): ét pr. besøgende pr. dag, temaet får kun de 9 felter. Kunden
     skraber; et felt åbner ved 50 %, og først når ALLE 9 er åbne, afgøres det: 3 ens = gevinst (e-mail -> /arcade/indloes,
     præmien registreres og kommer som engangskode i kurven), ellers "nyt lod i morgen". Kan serveren ikke nås, vises
     intet (ingen halv pop-up). Test: ?arcade=1 giver et nyt lod (ny besøgende).
     ------------------------------------------------------------------ */
  var arcade = document.getElementById('bm-arcade');
  if (!arcade) return;
  var API = 'https://club-api.street-bill.dk/arcade/';
  var SHOP = (window.Shopify && window.Shopify.shop) || '';

  /* ?arcade=1 (nyt lod) virker kun i preview - i den udgivne butik giver en genindlæsning altid samme lod */
  var force = /[?&]arcade=1/.test(location.search) && !(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main');
  if (force) ['bm_arcade_seen', 'bm_arcade_spun', 'bm_arcade_besoeger', 'bm_arcade_revealed', 'bm_arcade_luk', 'bm_arcade_nej'].forEach(function (k) { store(k, ''); });   // 29-10: ?arcade=1 nulstiller også "lukket 2 gange"
  /* 30-10 (Thomas: "når det blev lukket 2x? så gik den væk" + "hvis man så skraber loddet skal det selvfølgelig ikke bare åbne
     igen" + "popper fortsat kun op 1 gang"): loddet åbner af sig selv på hver ny side, til kunden har lukket det 2 gange eller har
     skrabet det. Huskes i localStorage, en cookie og fanens window.name, så reglen også holder, hvor browseren blokerer lagring
     (iPhone m.fl.: før kom loddet på hver side, uanset hvor mange gange det blev lukket) */
  var cookie = function (k) { var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + k + '=([^;]*)')); return m ? m[1] : ''; };
  var fane = function (k) { var m = (window.name || '').match(new RegExp('(?:^| )' + k + '=(\\S*)')); return m ? m[1] : ''; };
  var husk = function (k, v) {
    store(k, v);
    try { document.cookie = k + '=' + v + '; path=/; max-age=5184000; SameSite=Lax'; } catch (e) {}
    window.name = ((window.name || '').replace(new RegExp('(?:^| )' + k + '=\\S*', 'g'), '') + (v ? ' ' + k + '=' + v : '')).trim();
  };
  var hent = function (k) { return store(k) || cookie(k) || fane(k) || ''; };
  var lukninger = function () { return parseInt(hent('bm_arcade_luk'), 10) || 0; };
  if (force) ['bm_arcade_luk', 'bm_arcade_skrabet', 'bm_arcade_spun'].forEach(function (k) { husk(k, ''); try { document.cookie = k + '=; path=/; max-age=0'; } catch (e) {} });
  var besoeger = store('bm_arcade_besoeger');
  if (!/^[a-z0-9-]{8,64}$/i.test(besoeger || '')) {
    besoeger = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + '-' + Math.random().toString(36).slice(2, 12);
    store('bm_arcade_besoeger', besoeger);
  }

  var card = arcade.querySelector('[data-bm-scratch]');
  var foil = card.querySelector('canvas');
  var felter = [].slice.call(card.querySelectorAll('.bm-sc__felt'));
  var winEl = arcade.querySelector('[data-bm-sc-win]');
  var lostEl = arcade.querySelector('[data-bm-sc-lost]');
  var claim = arcade.querySelector('[data-bm-sc-claim]');
  var revealBtn = arcade.querySelector('[data-bm-sc-reveal]');
  var emailInput = arcade.querySelector('input[type="email"]');
  var errEl = arcade.querySelector('.bm-arcade__err');
  var resultEl = arcade.querySelector('.bm-arcade__result');
  var claimBtn = arcade.querySelector('[data-bm-claim]');
  var form = arcade.querySelector('form');
  var painted = false, done = false, lod = null, grid = [], vinder = null;
  var teaser = document.getElementById('bm-arcade-teaser');
  var visible = function (el) { return !!el && el.offsetWidth > 0 && el.offsetHeight > 0 && window.getComputedStyle(el).visibility !== 'hidden'; };
  var klaviyoPopup = function () {   // kun Klaviyos pop-up, ikke dens lille knap i hjørnet
    return [].some.call(document.querySelectorAll('div.needsclick[class*="kl-private-reset-css"]'), function (el) { return visible(el) && el.offsetHeight > 200; });
  };
  /* Den faste knap i hjørnet: vises indtil kunden har skrabet dagens lod - også når kunden har lukket loddet
     (29-10, Thomas: "bør den stadig ikke ligge som flisen i produkterne + nede i venstre hjørne?") */
  var syncTeaser = function () {
    if (!teaser) return;
    var hero = document.querySelector('.bm-front');
    var overHero = !!hero && hero.getBoundingClientRect().bottom > window.innerHeight * 0.35;   // dæk ikke heroens knapper
    teaser.hidden = !lod || store('bm_arcade_spun') === '1' || arcade.classList.contains('is-open') || visible(document.getElementById('bm-vault')) || overHero;
  };
  var api = function (sti, data) {
    return fetch(API + sti, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(Object.assign({ shop: SHOP }, data)) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { j.status = r.status; return j; }); });
  };

  /* Folien: én sølvflise pr. felt (med korn og ?), lagt præcis over felterne */
  var ctx, dpr = 1, rects = [], ratioTimer;
  function paintFoil() {
    if (painted) return;
    var w = foil.clientWidth, h = foil.clientHeight;
    if (!w || !h) return;
    painted = true;
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    foil.width = Math.round(w * dpr); foil.height = Math.round(h * dpr);
    ctx = foil.getContext('2d');
    ctx.scale(dpr, dpr);
    var cr = foil.getBoundingClientRect();
    rects = felter.map(function (el) { var r = el.getBoundingClientRect(); return { x: r.left - cr.left, y: r.top - cr.top, w: r.width, h: r.height }; });
    rects.forEach(function (r, i) {
      if (felter[i].classList.contains('is-open')) return;
      var g = ctx.createLinearGradient(r.x, r.y, r.x + r.w, r.y + r.h);
      g.addColorStop(0, '#a3a19a'); g.addColorStop(.35, '#e6e4dc'); g.addColorStop(.55, '#96948d'); g.addColorStop(1, '#d6d4cb');
      ctx.fillStyle = g; ctx.fillRect(r.x, r.y, r.w, r.h);
      for (var p = 0; p < 90; p++) { ctx.fillStyle = 'rgba(0,0,0,' + (Math.random() * .09).toFixed(3) + ')'; ctx.fillRect(r.x + Math.random() * r.w, r.y + Math.random() * r.h, 1.4, 1.4); }
      ctx.fillStyle = 'rgba(5,5,5,.55)'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = Math.round(Math.min(r.h * .5, 30)) + 'px Anton, Impact, sans-serif';
      ctx.fillText('?', r.x + r.w / 2, r.y + r.h / 2 + 1);
    });
    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = Math.max(26, w / 11);
  }
  function aabnFelt(i) {
    if (felter[i].classList.contains('is-open')) return;
    var r = rects[i];
    if (ctx && r) ctx.clearRect(r.x - 1, r.y - 1, r.w + 2, r.h + 2);
    felter[i].classList.add('is-open');
  }
  /* Først når hele loddet er skrabet: gevinst eller ej */
  function afgoer() {
    if (card.classList.contains('is-won') || card.classList.contains('is-lost')) return;
    store('bm_arcade_revealed', '1');
    husk('bm_arcade_skrabet', '1');   // 30-10: skrabet lod (gevinst eller nitte) åbner aldrig selv igen
    revealBtn.hidden = true;
    if (vinder) {
      felter.forEach(function (el, i) { if (grid[i] === vinder) el.classList.add('is-vinder'); });
      card.classList.add('is-won');
      winEl.hidden = false;
      claim.hidden = false;
    } else {
      card.classList.add('is-lost');
      lostEl.hidden = false;
      store('bm_arcade_spun', '1');
      syncTeaser();
    }
  }
  var alleAabne = function () { return felter.every(function (el) { return el.classList.contains('is-open'); }); };
  /* Et felt åbner, når halvdelen er skrabet (hver 8. pixel i feltet tælles) */
  function tjek() {
    rects.forEach(function (r, i) {
      if (felter[i].classList.contains('is-open')) return;
      var d = ctx.getImageData(Math.round(r.x * dpr), Math.round(r.y * dpr), Math.max(1, Math.round(r.w * dpr)), Math.max(1, Math.round(r.h * dpr))).data, t = 0, c = 0;
      for (var p = 3; p < d.length; p += 32) { t++; if (d[p] < 128) c++; }
      if (t && c / t >= .5) aabnFelt(i);
    });
    if (alleAabne()) afgoer();
  }
  function reveal() { felter.forEach(function (el, i) { aabnFelt(i); }); afgoer(); }
  var last = null, drawing = false, moves = 0;
  var pos = function (e) { var r = foil.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
  var stroke = function (p) {
    ctx.beginPath(); ctx.moveTo((last || p).x, (last || p).y); ctx.lineTo(p.x + .1, p.y + .1); ctx.stroke();
    last = p;
  };
  var check = function () { clearTimeout(ratioTimer); ratioTimer = setTimeout(tjek, 50); };
  foil.addEventListener('pointerdown', function (e) {
    if (!ctx || card.classList.contains('is-won') || card.classList.contains('is-lost')) return;
    drawing = true; last = null;
    try { foil.setPointerCapture(e.pointerId); } catch (err) {}
    card.classList.add('is-scratching');
    stroke(pos(e));
    e.preventDefault();
  });
  foil.addEventListener('pointermove', function (e) {
    if (!drawing) return;
    stroke(pos(e));
    if (++moves % 8 === 0) check();
  });
  var stop = function () { if (!drawing) return; drawing = false; last = null; check(); };
  foil.addEventListener('pointerup', stop);
  foil.addEventListener('pointercancel', stop);
  revealBtn.addEventListener('click', reveal);

  function loadFonts() {
    if (document.getElementById('bm-fonts')) return;
    var l = document.createElement('link');
    l.id = 'bm-fonts'; l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Anton&family=Archivo:wght@400;500;700&display=swap';
    document.head.appendChild(l);
  }

  var autoAaben = false;   // åbnet af sig selv (ikke af et klik)
  function open(e) {
    if (!lod) return;
    if (e) autoAaben = false;
    loadFonts();
    var show = function () {
      if (autoAaben && klaviyoPopup()) { autoAaben = false; syncTeaser(); return; }
      arcade.classList.add('is-open');
      document.documentElement.classList.add('bm-arcade-open');
      paintFoil();
      if (store('bm_arcade_revealed') === '1' || reduceMotion) reveal();
      syncTeaser();
    };
    if (document.fonts && document.fonts.load) {
      Promise.race([
        document.fonts.load('30px Anton'),
        new Promise(function (r) { setTimeout(r, 1200); })
      ]).then(show, show);
    } else { show(); }
  }
  function skjul() {
    arcade.classList.remove('is-open');
    document.documentElement.classList.remove('bm-arcade-open');
    syncTeaser();
  }
  /* 30-10 (Thomas: "når det blev lukket 2x? så gik den væk"): hver lukning tælles - efter 2 åbner loddet aldrig selv igen.
     Flisen mellem varerne og knappen i hjørnet bliver */
  function close() {
    husk('bm_arcade_luk', String(lukninger() + 1));
    skjul();
  }

  arcade.querySelector('.bm-arcade__close').addEventListener('click', close);
  arcade.addEventListener('click', function (e) { if (e.target === arcade) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && arcade.classList.contains('is-open')) close(); });
  emailInput.addEventListener('input', function () { errEl.textContent = ''; });
  lostEl.querySelector('button').addEventListener('click', close);

  var FEJL = { 'en-pr-email': 'Den e-mail har allerede vundet en præmie.', hentet: 'Præmien er allerede hentet.' };
  function claimPrize(e) {
    e.preventDefault();
    if (done) { close(); return; }
    var em = emailInput.value.trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)) { errEl.textContent = arcade.getAttribute('data-error') || ''; return; }
    claimBtn.disabled = true;
    api('indloes', { lod: lod, email: em }).then(function (svar) {
      claimBtn.disabled = false;
      if (!svar.tekst) { errEl.textContent = FEJL[svar.fejl] || 'Noget gik galt - prøv igen om lidt.'; return; }
      done = true;
      errEl.textContent = '';
      husk('bm_arcade_skrabet', '1');
      store('bm_arcade_spun', '1');
      /* Tilmelding til nyhedsbrev via Shopifys egen kundeformular (i baggrunden) */
      if (form && arcade.getAttribute('data-subscribe') === 'true') {
        try { fetch(form.getAttribute('action'), { method: 'POST', body: new FormData(form), credentials: 'same-origin' }).catch(function () {}); } catch (err) {}
      }
      resultEl.textContent = svar.tekst;
      /* Koden lægges på kurven med det samme; en vare-præmie (tote bag'en) lægges også i kurven og står til 0 kr. */
      if (svar.kode) {
        var vis = document.createElement('small');
        vis.textContent = 'Din kode: ' + svar.kode + ' - den er lagt i din kurv';
        resultEl.appendChild(vis);
        var rod = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        (svar.variant
          ? fetch(rod + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(svar.variant), quantity: 1, properties: { _bm_arcade: '1' } }] }) })
          : Promise.resolve({ ok: true }))
          .then(function (r) { if (!r.ok) throw new Error('kurv'); return fetch('/discount/' + encodeURIComponent(svar.kode), { credentials: 'same-origin' }); })
          .then(function () { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); })
          .catch(function () {
            /* 12-10: en vare-præmie virker kun med varen i kurven - "skriv koden" alene giver "kan ikke bruges" */
            vis.textContent = 'Din kode: ' + svar.kode + ' - ';
            var a = document.createElement('a');
            a.href = svar.link || ('/discount/' + encodeURIComponent(svar.kode));
            a.textContent = svar.variant ? 'læg tasken i kurven her' : 'brug den her';
            vis.appendChild(a);
          });
      }
      emailInput.hidden = true;
      claimBtn.textContent = arcade.getAttribute('data-continue') || 'Fortsæt';
      syncTeaser();
    }, function () { claimBtn.disabled = false; errEl.textContent = 'Noget gik galt - prøv igen om lidt.'; });
  }
  form.addEventListener('submit', claimPrize);

  /* Hent dagens lod; uden lod vises hverken pop-up, knap eller sektionens knap */
  var klar = api('lod', { besoeger: besoeger }).then(function (svar) {
    if (!svar.felter || svar.felter.length !== felter.length) return false;
    lod = svar.lod; grid = svar.felter;
    var t = {};
    grid.forEach(function (x) { t[x] = (t[x] || 0) + 1; });
    vinder = Object.keys(t).filter(function (x) { return t[x] === 3; })[0] || null;
    felter.forEach(function (el, i) { el.querySelector('b').textContent = grid[i]; });
    arcade.querySelector('[data-bm-sc-label]').textContent = vinder || '';
    var jp = arcade.querySelector('[data-bm-sc-jackpot]');
    if (jp && svar.jackpot) { jp.querySelector('[data-bm-sc-jackpot-label]').textContent = svar.jackpot; jp.hidden = false; }
    if (svar.hentet) { done = true; store('bm_arcade_spun', '1'); }
    syncTeaser();
    return true;
  }, function () { return false; });

  /* Tema-editoren: vis loddet når sektionen vælges */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(arcade)) klar.then(open); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(arcade)) arcade.classList.remove('is-open'); });
    return;
  }

  if (teaser) {
    if (document.querySelector('#preview-bar-iframe, #PBarNextFrameWrapper')) teaser.style.bottom = '84px';
    teaser.addEventListener('click', open);
    window.setInterval(syncTeaser, 2000);   // dukker op når vault-introen er slut
    window.addEventListener('scroll', syncTeaser, { passive: true });
  }
  /* Knapper i sektioner (fx forsidens Arcade-sektion og bannerne i kollektionsgitteret) åbner samme lod. 14-10: lyttes på
     dokumentet, så det også virker på bannere, der kommer ind, når kunden filtrerer (gitteret skiftes ud uden genindlæsning) */
  document.addEventListener('click', function (e) { if (e.target.closest('[data-bm-arcade-open]')) open(e); });

  /* Pop-up efter et par sekunder, én gang pr. besøgende - og først når cookie-banneret
     og en evt. Klaviyo-pop-up er væk, så kunden aldrig får to pop-ups oven i hinanden. */
  klar.then(function (ok) {
    if (!ok) { document.querySelectorAll('.bm-acta, .bm-gb--arcade').forEach(function (s) { s.hidden = true; }); return; }
    if (!force && (lukninger() >= 2 || hent('bm_arcade_skrabet') === '1')) return;   // 30-10: hver side, til lukket 2 gange eller skrabet   // 28-10 (Thomas): én gang pr. besøgende, på den side kunden lander på
    if (document.querySelector('[id$="__bm_vault"], #bm-vault, #bm-vaultlock')) return;   // 29-10 (Thomas): aldrig på The Vault (også når kunden er inde) - kommer på næste side
    var delay = force ? 600 : (parseFloat(arcade.getAttribute('data-delay')) || 4) * 1000, waited = 0;
    var tryOpen = function () {
      var blocked = visible(document.getElementById('bm-vault')) ||
        visible(document.getElementById('shopify-pc__banner')) ||
        visible(document.getElementById('cookies-wrapper')) ||   // Consentik-cookiebanneret (09-10: kortet åbnede oven i det)
        klaviyoPopup();
      if (blocked && waited < 120000) { waited += 1500; window.setTimeout(tryOpen, 1500); return; }
      if (blocked) return;
      /* 30-10: åbner af sig selv på hver ny side, til kunden har lukket det 2 gange eller skrabet det (se lukninger/hent ovenfor) */
      autoAaben = true;
      open();
      /* 28-10: Klaviyos pop-up kom 4 s efter og lagde sig under loddet (to pop-ups). Kommer den, før kunden har rørt loddet,
         trækker loddet sig - knappen i hjørnet bliver, så det kan åbnes bagefter */
      var vagt = window.setInterval(function () {
        if (!autoAaben || card.classList.contains('is-scratching') || done) { window.clearInterval(vagt); return; }
        if (klaviyoPopup()) { autoAaben = false; window.clearInterval(vagt); skjul(); }
      }, 500);
      window.setTimeout(function () { window.clearInterval(vagt); }, 30000);
    };
    window.setTimeout(tryOpen, delay);
  });
})();

/* ------------------------------------------------------------------
   KURV-DEAL (12-10, Thomas: "kurv funktionen ... crazy god ... flere ting"): tilkøb til deal-pris fra produktsiden og
   kurvskuffen (snippets/bm-kurvdeal.liquid). + folder størrelserne ud, "Læg i kurv" lægger én stk. i kurven, og status
   ("låst op" / "køb for X kr mere") regnes om, når kurven ændres - samme regel som Club-appens rabat: tilbudsvarerne og
   trappens gaver tæller ikke med mod grænsen.
   ------------------------------------------------------------------ */
(function () {
  var rod = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var kr = function (oere) { return Math.ceil(oere / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr'; };
  var opdater = function (kurv) {
    document.querySelectorAll('[data-bm-kd]').forEach(function (boks) {
      var min = Number(boks.getAttribute('data-min')), ikke = boks.getAttribute('data-ikke') || ',';
      var i = ',', base = 0;
      kurv.items.forEach(function (l) {
        i += l.product_id + ',';
        if (ikke.indexOf(',' + l.product_id + ',') < 0) base += l.original_line_price;
      });
      var mangler = min - base;
      var status = boks.querySelector('[data-bm-kd-status]');
      if (status) status.textContent = mangler <= 0 ? boks.getAttribute('data-t-aaben') : boks.getAttribute('data-t-mangler').replace('{kr}', kr(mangler));
      boks.classList.toggle('is-aaben', mangler <= 0);
      var bar = boks.querySelector('[data-bm-kd-bar]');
      if (bar) bar.style.setProperty('--p', Math.min(100, Math.round(base * 100 / min)) + '%');
      boks.querySelectorAll('[data-bm-kd-vare]').forEach(function (v) {
        v.classList.toggle('is-i-kurv', i.indexOf(',' + v.getAttribute('data-produkt') + ',') >= 0);
      });
    });
  };
  /* 16-10: fyld-op-varerne (data-egenskab="_bm_hjaelper:kurv-fyld") er almindelige varer - kun deal-varerne får _bm_kurvdeal */
  var egenskab = function (v) {
    var e = (v.getAttribute('data-egenskab') || '').split(':'), p = {};
    if (e.length === 2) { p[e[0]] = e[1]; return p; }
    return { _bm_kurvdeal: '1' };
  };
  var hent = function () {
    if (!document.querySelector('[data-bm-kd]')) return;
    fetch(rod + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(opdater).catch(function () {});
  };
  document.addEventListener('cart:change', function () { setTimeout(hent, 200); });
  /* 14-10 bud B: + folder størrelserne ud (én vare ad gangen); "Læg i kurv" virker først, når en størrelse er valgt */
  document.addEventListener('click', function (e) {
    var aaben = e.target.closest('[data-bm-kd-aaben]');
    if (aaben) {
      var raekke = aaben.closest('[data-bm-kd-vare]'), valg = raekke.querySelector('.bm-kd__valg'), vis = valg.hidden;
      aaben.closest('[data-bm-kd]').querySelectorAll('.bm-kd__valg').forEach(function (x) {
        x.hidden = true;
        var b = x.closest('[data-bm-kd-vare]').querySelector('[data-bm-kd-aaben]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      valg.hidden = !vis;
      aaben.setAttribute('aria-expanded', String(vis));
      return;
    }
    /* 21-10: bladring i fyld-listen (3 ad gangen, som checkoutens "Læg til ordren") */
    var blad = e.target.closest('[data-bm-kd-bladr]');
    if (blad) {
      var boks = blad.closest('[data-bm-kd-blad]'), sider = Number(boks.getAttribute('data-sider')) || 1;
      var nu = Math.max(0, Math.min(sider - 1, (Number(boks.getAttribute('data-nu')) || 0) + Number(blad.getAttribute('data-bm-kd-bladr'))));
      boks.setAttribute('data-nu', String(nu));
      var liste = boks.closest('.bm-kd__fyldtop').nextElementSibling;
      if (liste) liste.querySelectorAll('[data-side]').forEach(function (li) { li.hidden = li.getAttribute('data-side') !== String(nu); });
      boks.querySelector('[data-bm-kd-side]').textContent = (nu + 1) + '/' + sider;
      boks.querySelector('[data-bm-kd-bladr="-1"]').disabled = nu === 0;
      boks.querySelector('[data-bm-kd-bladr="1"]').disabled = nu === sider - 1;
      return;
    }
    var str = e.target.closest('[data-bm-kd-str]');
    if (str) {
      var r = str.closest('[data-bm-kd-vare]'), add = r.querySelector('.bm-kd__knap');
      r.setAttribute('data-variant', str.getAttribute('data-bm-kd-str'));
      r.querySelectorAll('[data-bm-kd-str]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === str)); });
      if (add) { add.disabled = false; add.textContent = add.getAttribute('data-tekst'); }
      return;
    }
    var knap = e.target.closest('[data-bm-kd-add]');
    if (!knap) return;
    var v = knap.closest('[data-bm-kd-vare]');
    if (!v.getAttribute('data-variant')) return;
    var tekst = knap.classList.contains('bm-kd__knap');
    knap.disabled = true;
    if (tekst) knap.textContent = '...';
    fetch(rod + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(v.getAttribute('data-variant')), quantity: 1, properties: egenskab(v) }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('kurv');
      knap.disabled = false;
      if (tekst) knap.textContent = knap.getAttribute('data-tekst');
      v.classList.add('is-i-kurv');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      hent();
    }).catch(function () {
      knap.disabled = false;
      if (tekst) knap.textContent = knap.getAttribute('data-fejl');
    });
  });
  /* 03-11 fart: tilkøbslisten hentes først, når kurvskuffen er åben (cart-drawer får attributten open) - eller med det samme,
     hvis pladsholderen står uden for skuffen */
  var fyldHent = function (ph) {
    ph.setAttribute('data-bm-kd-obs', '1');
    fetch(rod + '?sections=bm-kd-fyld', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var d = new DOMParser().parseFromString(j['bm-kd-fyld'] || '', 'text/html');
      var liste = d.querySelector('.bm-kd__liste--fyld'), fp = d.querySelector('.bm-kd__fyld');   // deal-listen har også en .bm-kd__fyldtop
      var top = liste ? liste.previousElementSibling : (fp && fp.parentElement);
      if (!ph.isConnected) return;
      if (!top) { ph.remove(); return; }
      var frag = document.createDocumentFragment();
      frag.appendChild(document.importNode(top, true));
      if (liste) frag.appendChild(document.importNode(liste, true));
      ph.replaceWith(frag);
    }).catch(function () {});
  };
  var fyldSe = function () {
    document.querySelectorAll('[data-bm-kd-fyld-lazy]:not([data-bm-kd-obs])').forEach(function (ph) {
      var skuffe = ph.closest('cart-drawer');
      if (!skuffe || skuffe.hasAttribute('open')) fyldHent(ph);
    });
  };
  new MutationObserver(fyldSe).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
  fyldSe();
  /* 03-11 (Thomas: "S i tøj, men skoene er i alle mulige størrelser"): kundens størrelse gemmes på kurven (_sko_str / _toej_str),
     så kurven og kassen kun viser den kategori i den størrelse */
  document.addEventListener('change', function (e) {
    var valg = e.target.closest('[data-bm-kd-strvalg]');
    if (!valg) return;
    var attr = {}; attr[valg.getAttribute('data-bm-kd-strvalg')] = valg.value;
    valg.classList.toggle('is-valgt', !!valg.value);
    valg.disabled = true;
    fetch(rod + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attr })
    }).then(function () {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(function () { valg.disabled = false; });
  });
})();

/* ---------------- THE DROP v2 (12-10): farvevalg på flash sale-kortene + preview-skift ---------------- */
/* Farve = en anden vare i samme flash sale: billede, links og pris skiftes (sections/bm-drop.liquid, snippets/bm-drop-kort.liquid).
   ?drop=duel / ?drop=alle viser den anden visning; kun preview har begge i siden. */
(function () {
  if (new URLSearchParams(location.search).get('nedtaelling') === '1') document.querySelectorAll('[data-bm-sidste]').forEach(function (el) { el.hidden = false; });
  var vis = new URLSearchParams(location.search).get('drop');
  if (vis === 'duel' || vis === 'alle') {
    document.querySelectorAll('.bm-drop [data-bm-drop-mode]').forEach(function (el) {
      el.hidden = el.getAttribute('data-bm-drop-mode') !== vis;
    });
  }
  document.addEventListener('click', function (e) {
    var knap = e.target.closest('[data-bm-dk-farve]');
    if (!knap) return;
    var kort = knap.closest('[data-bm-dk]');
    var img = kort.querySelector('[data-bm-dk-billede]');
    if (img) { img.srcset = knap.getAttribute('data-srcset'); img.src = knap.getAttribute('data-src'); }
    kort.querySelectorAll('[data-bm-dk-link]').forEach(function (a) { a.href = knap.getAttribute('data-url'); });
    var pris = kort.querySelector('[data-bm-dk-pris]'), foer = kort.querySelector('[data-bm-dk-foer]');
    if (pris) pris.textContent = knap.getAttribute('data-pris');
    if (foer) foer.textContent = knap.getAttribute('data-foer');
    kort.querySelectorAll('[data-bm-dk-farve]').forEach(function (k) { k.setAttribute('aria-pressed', k === knap ? 'true' : 'false'); });
  });
})();

/* ---------------- THE VAULT på én side (12-10, Thomas): Shopify viser højst 50 varer pr. side - side 2+ hentes og sættes
   ind i samme gitter, og side-linkene skjules (sections/main-collection.liquid, [data-bm-hent-alle]) ---------------- */
(function () {
  var maerke = document.querySelector('[data-bm-hent-alle]');
  if (!maerke) return;
  var liste = document.querySelector('.collection__results product-list');
  if (!liste) return;
  var sider = Number(maerke.getAttribute('data-bm-hent-alle')), hent = [];
  for (var p = 2; p <= sider; p++) {
    var url = new URL(location.href);
    url.searchParams.set('page', p);
    hent.push(fetch(url.toString(), { credentials: 'same-origin' }).then(function (r) { return r.text(); }));
  }
  Promise.all(hent).then(function (sider) {
    sider.forEach(function (html) {
      var ny = new DOMParser().parseFromString(html, 'text/html').querySelector('.collection__results product-list');
      if (ny) [].slice.call(ny.children).forEach(function (kort) { liste.appendChild(document.importNode(kort, true)); });
    });
    var nav = document.querySelector('.collection__results ~ .pagination, .collection__inner .pagination');
    if (nav) nav.style.display = 'none';
  }).catch(function () {});
})();

/* ---------------- Ingen huller i kollektionsgitteret (27-10, Thomas: "kollektionssiderne fucker komplet op"): 36 varer + 3 bannere
   = 39 felter, så sidste række fik et sort hul på 4 kolonner. Det sidste banner gøres så bredt, at rækkerne går op - uanset hvor
   mange kolonner gitteret har (bredden og visnings-knapperne styrer det). "dense" lader varerne efter banneret fylde op foran det.
   Mobil (banner = hel række) og færre end 3 kolonner røres ikke. ---------------- */
(function () {
  function fyld(liste) {
    var bannere = liste.querySelectorAll(':scope > .bm-gb');
    if (!bannere.length) return;
    bannere.forEach(function (b) { b.style.gridColumn = ''; });
    liste.style.gridAutoFlow = '';
    var kol = getComputedStyle(liste).gridTemplateColumns.split(' ').length;
    if (kol < 3) return;
    var felter = [].filter.call(liste.children, function (e) {
      return !/^(SCRIPT|TEMPLATE|STYLE)$/.test(e.tagName) && !e.hidden && getComputedStyle(e).display !== 'none';
    }).length;
    var huller = (kol - felter % kol) % kol;
    if (!huller) return;
    var sidste = [].filter.call(bannere, function (b) { return !b.hidden; }).pop();
    if (!sidste) return;
    sidste.style.gridColumn = 'span ' + Math.min(kol, 1 + huller);
    liste.style.gridAutoFlow = 'row dense';
  }
  document.querySelectorAll('product-list').forEach(function (liste) {
    if (!liste.querySelector(':scope > .bm-gb')) return;
    var vent;
    var igen = function () { clearTimeout(vent); vent = setTimeout(function () { fyld(liste); }, 60); };
    fyld(liste);
    if (window.ResizeObserver) new ResizeObserver(igen).observe(liste);
    new MutationObserver(igen).observe(liste, { childList: true, attributes: true, attributeFilter: ['hidden', 'desktop-layout', 'mobile-items-per-row'] });
  });
})();

/* ------------------------------------------------------------------
   KOLLEKTIONSGITTERET (29-10, Thomas: "kollektionssiderne virker stadigvæk ikke her på side 2 går den galt"): 36 varer + 3
   bannere = 39 pladser, så sidste række manglede én på 4 kolonner. Bannerne må aldrig efterlade huller: tættest mulig
   pakning, og sidste synlige banner bliver bredt nok til, at sidste række er fuld. Mobil: bannerne er hele rækker (CSS).
   ------------------------------------------------------------------ */
(function () {
  var span = function (el) {
    var cs = getComputedStyle(el), m = /span (\d+)/.exec(cs.gridColumnStart + ' ' + cs.gridColumnEnd);
    return m ? parseInt(m[1], 10) : 1;
  };
  var synlig = function (el) { return el.tagName !== 'SCRIPT' && !el.hidden && getComputedStyle(el).display !== 'none'; };
  var fyld = function () {
    document.querySelectorAll('product-list, .product-list').forEach(function (g) {
      var bannere = [].slice.call(g.children).filter(function (k) { return k.classList.contains('bm-gb') && synlig(k); });
      if (!bannere.length) return;
      bannere.forEach(function (b) { b.style.gridColumn = ''; });
      g.style.gridAutoFlow = '';
      if (window.matchMedia('(max-width: 699px)').matches) return;
      var kol = getComputedStyle(g).gridTemplateColumns.split(' ').filter(Boolean).length;
      if (kol < 2) return;
      var celler = [].slice.call(g.children).filter(synlig).reduce(function (n, k) { return n + Math.min(span(k), kol); }, 0);
      var hul = (kol - celler % kol) % kol;
      g.style.gridAutoFlow = 'row dense';
      if (!hul) return;
      var sidst = bannere[bannere.length - 1];
      sidst.style.gridColumn = 'span ' + Math.min(kol, span(sidst) + hul);
    });
  };
  var t;
  var igen = function () { clearTimeout(t); t = setTimeout(fyld, 120); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fyld); else fyld();
  window.addEventListener('load', fyld);
  window.addEventListener('resize', igen);
  window.bmFyldGitter = fyld;
  /* 29-10 (Thomas: "den bugger på side 2"): sideskift og filtre henter varerne uden at genindlæse siden - kør igen, når gitteret skifter */
  new MutationObserver(function (m) {
    if (m.some(function (r) { return r.target.closest && r.target.closest('product-list, .product-list, main'); })) igen();
  }).observe(document.body, { childList: true, subtree: true });
})();
